<template>
  <div>
    <div class="station-name">
      <i class="fa fa-map-marker text-danger align-baseline"/>&nbsp;
      <span class="text-monospace">{{ selectedStation.NAME }}</span>
    </div>
    <spinner
      v-if="isFetching"
      color="loader-dark-blue"/>
    <div v-if="!isFetching">
      <b-table
        :items="availableCars"
        :fields="carFields"
        striped
        responsive>
        <template
          v-slot:cell(UNLOCK)="row">
          <label class="switch switch-pill switch-success">
            <input
              :checked="row.item.UNLOCK"
              :disabled="row.item.IS_BOOKED"
              :license-plate="row.item.LICENSE_PLATE"
              :car-code="row.item.CODE"
              type="checkbox"
              class="switch-input"
              @input="setLockUnlock">
            <span class="switch-slider"/>
          </label>
        </template>
        <template
          slot="STATUS"
          slot-scope="row">
          {{ row.item.IS_BOOKED ? 'Not available' : 'Available' }}
          <span v-if="row.item.NOTE">({{ row.item.NOTE }})</span>
        </template>
      </b-table>
      <b-btn
        :disabled="!isButtonEnabled || isPostingReservation"
        class="mt-3"
        block
        variant="primary"
        @click="next">
        Next
        <i
          v-show="!isPostingReservation"
          class="icon-arrow-right"/>
        <i
          v-show="isPostingReservation"
          class="fa fa-spin fa-spinner"
          aria-hidden="true"/>
      </b-btn>
      <b-btn
        block
        variant="secondary"
        @click="back()">Back to Station Selection</b-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import Spinner from '@/components/Spinner'
import { server, toastr, auth } from '@/services/'
import { sendEvent } from '@/services/socket'

export default {
  name: 'CleaningForm2',
  components: {
    Spinner
  },
  data () {
    return {
      carFields: [
        'NAME',
        'LICENSE_PLATE',
        'UNLOCK',
        'STATUS'
      ]
    }
  },
  computed: {
    ...mapState('cleaning', [
      'selectedStation',
      'availableCars',
      'isFetching',
      'isPostingReservation'
    ]),
    ...mapGetters('cleaning', {
      unlockedCars: 'getUnlockedCars'
    }),
    isButtonEnabled() {
      if (this.unlockedCars.length) {
        return true
      }
    }
  },
  created () {
    if (this.availableCars.length) {
      this.$store.commit('cleaning/setIsFetching', true)
      let bookingPromises = []
      this.availableCars.forEach(car => {
        bookingPromises.push(this.getBookingStatus(car.CODE))
      })
      Promise.all(bookingPromises).then(
        resp => {
          for (let i = 0; i < bookingPromises.length; i++) {
            let payload = {
              carCode: `CARS-${resp[i].data.msgContent.cocosCarId}`,
              isBooked: resp[i].data.msgContent.cocosCarIsBooked,
              note: resp[i].data.msgContent.cocosBookingNote
            }
            this.$store.commit('cleaning/setBookingStatus', payload)
            this.$store.commit('cleaning/setIsFetching', false)
          }
        }
      )
    }
  },
  methods: {
    setLockUnlock (e) {
      let carCode = e.target.getAttribute('car-code')
      let status = e.target.checked
      // let unlockPayload = {
      //   carCode: carCode,
      //   carLockUnlock: status ? 1 : 0
      // }
      this.$store.commit('cleaning/setUnlockStatus', {carCode: carCode, unlock: status})
    },
    getBookingStatus (carCode) {
      let dateTime = ''
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz === 'Asia/Jakarta') {
        dateTime = moment().add(1, 'h').format('YYYY-MM-DD HH:mm:ss')
      } else {
        dateTime = moment().format('YYYY-MM-DD HH:mm:ss')
      }
      let payload = {
        carCode: carCode,
        dateTime: dateTime
      }
      return server.post('/proxy/cocos/getCarBookingStatus', payload)
    },
    next () {
      sendEvent('CLEANER_EVENT', {
        page: '/cleaning',
        eventName: 'SUBMIT_UNLOCK_VEHICLE',
        eventDetail: {
          licensePlate: this.unlockedCars.map(car => car.LICENSE_PLATE),
          stationName: this.selectedStation.NAME
        }
      })
      this.$store.commit('cleaning/setIsPostingReservation', true)
      localStorage.setItem('unlockedCars', JSON.stringify(this.unlockedCars))
      let reservationPromises = []

      this.unlockedCars.forEach(car => {
        let unlockPayload = {
          carCode: car.CODE,
          carLockUnlock: 1
        }
        let reservationPayload = {
          licensePlate: car.LICENSE_PLATE,
          zoneCode: this.selectedStation.ZONE_CODE,
          stationCode: this.selectedStation.CODE,
          startDate: moment().format('YYYY-MM-DD HH:mm'),
          endDate: moment().add(1, 'h').format('YYYY-MM-DD HH:mm')
        }
        // Execute unlock first, push reservation payload to be executed after.
        this.$store.dispatch('cleaning/lockUnlockCar', unlockPayload).then(
          resp => {
            let { data } = resp
            if (!data.msgContent.errMsg && data.msgContent.status > 0) {
              toastr.info(`${car.LICENSE_PLATE} successfully unlocked`)
            } else {
              toastr.error(`Failed to unlock ${car.LICENSE_PLATE}`)
            }
          },
          () => toastr.error(`Failed to unlock ${car.LICENSE_PLATE}`)
        )
        reservationPromises.push(this.$store.dispatch('cleaning/createReservation', reservationPayload))
      })
      // execute reservation(s)
      Promise.all(reservationPromises).then(
        () => {
          this.$store.commit('cleaning/setIsPostingReservation', false)
          this.$store.commit('cleaning/setSteps', 3)
        },
        err => {
          console.log(err)
        }
      )
    },
    back () {
      location.reload()
    }
  },
}
</script>
